import { SVGProps } from 'react'

const CircleCheck = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || '21'}
      height={props.height || '20'}
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='flex-shrink-0'
      {...props}
    >
      <path
        d='M10.5 20C4.977 20 0.5 15.523 0.5 10C0.5 4.477 4.977 0 10.5 0C16.023 0 20.5 4.477 20.5 10C20.5 15.523 16.023 20 10.5 20Z'
        fill={props.fill || '#1977EC'}
      />
      <path
        d='M8.743 14.485L4.5 10.242L5.914 8.828L8.743 11.657L14.399 6L15.814 7.414L8.743 14.485Z'
        fill='white'
      />
    </svg>
  )
}

export default CircleCheck
